import * as yup from 'yup';

const addressSchema = yup.object().shape({
  countryIso2Code: yup.string().required().max(2).label('Country'),
  region: yup
    .string()
    .when('countryIso2Code', {
      is: 'ZA',
      then: yup.string().required().max(100),
    })
    .label('Region'),
  localArea: yup.string().required().max(200).label('Suburb or area'),
  city: yup.string().required().max(200).label('City or town'),
  street: yup.string().required().max(200).label('Street address'),
  house: yup.string().required().max(50).label('House number'),
  apartmentNumber: yup.string().max(50).label('App, flat or floor number'),
  buildingName: yup.string().max(50).label('Building or complex'),
  postCode: yup.string().required().max(4).label('Postal Code'),
});

export default addressSchema;
